<router-outlet></router-outlet>
<app-menu [hidden]="verifyAuth || !showMenu"></app-menu>